import _ from 'lodash';

/**
 * Default is 0
 * @param {Object} pagination
 * @param {String} key
 * @returns {Number}
 */
export const selectCurrentPage = (pagination, key) => _.get(pagination, key + '.currentPage', 0);

/**
 * @param {Object} pagination
 * @param {String} key
 * @param {Number|String} page | default to current selected or 0
 * @returns {Array<string>|undefined}
 */
export const selectIds = (pagination, key, page = selectCurrentPage(pagination, key)) => {
    return _.get(pagination, key + '.pages.' + page);
};

/**
 * Default is 10
 * @param {Object} pagination
 * @param {String} key
 * @returns {Number}
 */
export const selectPerPage = (pagination, key) => _.get(pagination, key + '.perPage', 10);

/**
 * Default is 0
 * @param {Object} pagination
 * @param {String} key
 * @returns {Number}
 */
export const selectCount = (pagination, key) => _.get(pagination, key + '.count', 0);



/** WEBPACK FOOTER **
 ** ../src/dash/front/selectors/pagination.js
 **/